document.addEventListener("DOMContentLoaded", function () {
    var swiperContainer = document.querySelector(".mySwiper.logolist-slider .swiper-wrapper");
    const categoryList = document.querySelector('.itg-collection');
    var slides = swiperContainer ? swiperContainer.querySelectorAll(".swiper-slide").length : 0;
    
    var swiper = new Swiper(".mySwiper.logolist-slider", {
        loop: false,
        spaceBetween: 20,
        speed: 500,
        pauseOnMouseEnter: true,
        breakpoints: {
            0: {
                slidesPerView: 2.5,
                speed: 500,
            },
            500: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 5,
            }
        },
        navigation: {
         nextEl: ".cstm-featured-product.next",
         prevEl: ".cstm-featured-product.prev",
       },
    });

    // Check if slides are greater than 4, then show arrows
    if(categoryList){
        if (slides > 4) {
            document.querySelector(".cstm-featured-product.next").style.display = "flex";
            document.querySelector(".cstm-featured-product.prev").style.display = "flex";
        } else {
            document.querySelector(".cstm-featured-product.next").style.display = "none";
            document.querySelector(".cstm-featured-product.prev").style.display = "none";
        }
    }
});
